<template lang="jade">
#app
    .header-top
      el-input(v-model="query",style="width:240px;margin-right:10px;",placeholder="请输入搜索内容" ,clearable=true, class="input-with-select",size='mini' , @keyup.enter.native="search")
      el-button(@click="search" , icon="el-icon-search" ,type="primary",size='mini') 搜索
    .header
      el-image(src="http://whxindi.com/newcms/static/toplogo.png",style="height:66px;" ,@click="$router.push({ path: `/` })",fit="contain")
      .menus
        el-menu(v-if="showmenu",:default-active="$route.path" style="" ,class="el-menu-demo",mode="horizontal",active-text-color="#409eff",v-bind:class="{ toppost : $route.path == '/' }" router)
            el-menu-item(index="/",style="margin-left:auto") 首页
            //- el-menu-item(index="/goto") 关于我们
            el-submenu(index="/goto" menu-trigger="hover")
              template(slot="title" ) 关于我们
              el-menu-item(index="/goto?menu=公司简介") 公司简介
              el-menu-item(index="/goto?menu=组织架构") 组织架构
              el-menu-item(index="/goto?menu=荣誉资质") 荣誉资质
              el-menu-item(index="/goto?menu=企业文化") 企业文化
              el-menu-item(index="/goto?menu=人才招聘") 人才招聘
              el-menu-item(index="/goto?menu=联系我们") 联系我们
            //- el-menu-item(index="/news") 新闻动态
            el-submenu(index="/news" menu-trigger="hover")
              template(slot="title" ) 新闻动态
              el-menu-item(index="/news?menu=公司动态") 公司新闻
              el-menu-item(index="/news?menu=行业动态") 行业动态
            el-menu-item(index="/product") 服务范围
            //- el-menu-item(index="/bidding") 招投标信息
            el-submenu(index="/bidding" menu-trigger="hover")
              template(slot="title" ) 招投标信息
              el-menu-item(index="/bidding?menu=招标公告") 招标公告
              el-menu-item(index="/bidding?menu=中标公示") 中标公示
            el-menu-item(index="/anli") 业绩展示
    transition(enter-active-class="animated")
      router-view
    div.copyright
      p All rights reserved © 2017. 武汉新地工程造价咨询有限公司  地址：武汉市江岸区金桥大道107号凯信大厦1栋19楼
      p 电话：027-82790915 027-82790916 027-82790917 027-82790918
      p 备案号：
        el-link(type="info",href="https://beian.miit.gov.cn/" target="_blank")鄂ICP备16002979号-2
      p 工信部查询网址：
        el-link(type="info",href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank") https://beian.miit.gov.cn/#/Integrated/index
</template>

<script>
  import axios from './router/http'

  export default {
    name: 'App',
    data() {
      return {
        query: null,
        showmenu: true,
        appurl: '',
        transitionName: '',
        activeIndex: '/',
        hrefdata: [
          [
            {
              href: '/goto',
              text: '关于我们',
            },
            {
              href: '/goto',
              text: '发展历程',
            },
            {
              href: '/goto',
              text: '企业文化',
            },
            {
              href: '/goto',
              text: '资质荣誉',
            },
            {
              href: '/goto',
              text: '合作伙伴',
            },
          ],
          [
            {
              href: '/news',
              text: '新闻动态',
            },
            {
              href: '/news',
              text: '公司新闻',
            },
            {
              href: '/news',
              text: '行业动态',
            },
          ],
          [
            {
              href: '/product',
              text: '产品中心',
            },
          ],
          [
            {
              href: '/anli',
              text: '业绩展示',
            },
            {
              href: '/recruitment',
              text: '诚聘英才',
            },
            {
              href: '/study',
              text: '学习模块',
            },
          ],
          [
            {
              href: '/help',
              text: '帮助中心',
            },
            {
              href: '/about',
              text: '联系我们',
            },
          ],
          [
            {
              href: '/about',
              text: '',
            },
            {
              href: null,
              text: '',
            },
            {
              href: null,
              text: '',
            },
            {
              href: null,
              text: '',
            },
          ],
        ],
      }
    },
    comments: {},
    created: function() {
      axios
        .get('/DataDictionary/GetDataDictionaryAll', {
          params: {
            key: '邮箱,电话,地址,APP下载地址',
          },
        })
        .then((response) => {
          console.log(response)
          this.hrefdata[5][0].text = '联系我们'
          this.hrefdata[5][1].text = '邮箱：' + response.data.result[0].value
          this.hrefdata[5][2].text = '电话：' + response.data.result[1].value
          this.hrefdata[5][3].text = '地址：' + response.data.result[2].value
          this.appurl = response.data.result[3].Content
        })
    },
    watch: {
      $route: function(to, form) {
        let url = to.fullPath
        if (url.indexOf('admin') !== -1) {
          this.showmenu = false
          return
        } else if (url.indexOf('login') !== -1) {
          this.showmenu = false
          return
        } else {
          this.showmenu = true
          return
        }
      },
    },
    methods: {
      search() {
        if (this.query == null || this.query === '') {
          this.$message({
            message: '请输入搜索内容',
            type: 'warning',
          })
          return
        }
        this.$router.push({ path: `/search?query=` + this.query })
      },
    },
  }
</script>

<style lang="less">
  @import './../static/css/public.min.css';
  body {
    padding: 0;
    margin: 0;
  }
  html,
  body,
  div,
  span,
  iframe,
  blockquote,
  pre,
  a,
  address,
  big,
  cite,
  code,
  del,
  em,
  font,
  img,
  ins,
  small,
  strong,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend {
    margin: 0;
    padding: 0;
  }
  html,
  body,
  div,
  p,
  a,
  h1,
  h2,
  h3,
  h4,
  h5,
  li,
  ol,
  ul,
  strong,
  span {
    font-family: '微软雅黑';
  }
  li,
  ol,
  ul {
    list-style: none outside;
  }
  :focus {
    outline: 0;
  }
  a img {
    border: 0;
  }
  a {
    text-decoration: none;
  }
  img {
    vertical-align: middle;
  }
  table {
    empty-cells: show;
  }
  ins {
    text-decoration: none;
  }
  del {
    text-decoration: line-through;
  }
  em {
    font-style: normal;
  }
  button::-moz-focus-inner,
  input[type='reset']::-moz-focus-inner,
  input[type='button']::-moz-focus-inner,
  input[type='submit']::-moz-focus-inner,
  input[type='file'] > input[type='button']::-moz-focus-inner {
    border: 0;
    padding: 0;
  }
  a {
    transition: color 0.4s ease-in-out;
    -moz-transition: color 0.4s ease-in-out;
    -webkit-transition: color 0.4s ease-in-out;
    -o-transition: color 0.4s ease-in-out;
  }
  * {
    font-family: 'Helvetica';
    box-sizing: border-box;
  }
  .pagetop {
    width: 100%;
    height: 500px;
    background-size: cover;
    background-position: center center;
  }
  .pagetop h1 {
    margin: 0;
    line-height: 500px;
    text-align: center;
    color: #fff;
    font-size: 45px;
    font-weight: 400;
  }
  .pull-left {
    float: left;
  }
  .pull-right {
    float: right;
  }
  .pos_r {
    position: relative;
  }
  .pos_a {
    position: absolute;
  }
  .text-right {
    text-align: right;
  }
  .text-left {
    text-align: left;
  }
  .overh {
    overflow: hidden;
  }
  .line-group {
    > h3 {
      font-size: 34px;
      font-weight: normal;
      color: #333333;
      text-align: center;
      margin: 20px 0;
    }
  }
  .top-cover {
    padding-top: 9%;
    text-align: center;
    position: absolute;
    top: 0;
    width: 100%;
    min-width: 1320px;
    h1 {
      font-size: 42px;
      color: #fff;
    }
    span {
      width: 165px;
      height: 1px;
      background-color: #fff;
      display: block;
      margin: 16px auto 0;
    }
    p {
      font-size: 22px;
      color: #fff;
      margin-top: 32px;
      display: block;
    }
  }
  .el-menu-item {
    font-size: 1em !important;
  }
  .copyright {
    margin-top: 50px;
    background: #414141;
    color: #fff;
    text-align: center;
    font-size: 14px;
    padding: 10px 0;
  }
</style>

<style scoped>
  .header-top {
    height: 45px;
    background: #f0f0f0;
    padding: 0 100px;
    text-align: right;
    line-height: 45px;
  }
  .header {
    display: flex;
    padding: 0 100px;
    height: 130px;
    align-items: center;
    position: sticky;
    top: 0px;
    z-index: 999;
    background: #fff;
    width: 100%;
  }
  .menus {
    margin-left: auto;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: end;
  }
  .menus >>> .el-submenu__title {
    font-size: 1em;
    padding: 0 3px;
  }
  .toppost {
    position: absolute;
    z-index: 999;
  }
  .el-menu {
    border-bottom: none;
  }
  .el-menu-item a {
    width: 100%;
    height: 100%;
    display: block;
    text-decoration: none;
  }
  .bottombox {
    width: 100%;
    overflow: hidden;
    background-color: rgb(23, 103, 161);
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-start;
    align-content: flex-start;
    padding: 1.4% 3%;
  }
  .bottombox ul {
    float: left;
    list-style: none;
    padding: 0 1.5%;
    min-height: 216px;
  }
  .bottombox ul:nth-of-type(1) {
    margin-left: 5%;
  }
  .bottombox ul li:first-child {
    margin-bottom: 10px;
  }
  .bottombox ul li:first-child a:after {
    content: '';
    display: block;
    width: 20px;
    height: 2px;
    background: #fff;
  }
  .bottombox ul:nth-child(6) {
    border-right: 0;
  }
  .bottombox ul:nth-child(6) li:first-child {
    margin: 0;
  }

  .bottombox ul li {
    line-height: 36px;
  }
  .bottombox ul li:first-child a {
    font-size: 20px;
    color: #d4edff;
  }
  .bottombox ul li a {
    text-decoration: none;
    color: #f7f7f7;
    font-weight: 300;
  }
  .bottombox ul li a:hover {
    color: #89d0f9;
  }
  .bottomercode {
    width: 170px;
    position: absolute;
    right: 10%;
    margin-top: 10px;
    padding: 15px;
    background: #fff;
    border: 2px solid #125688;
  }
  .topdoli {
    float: right;
    line-height: 60px;
    margin-right: 6%;
  }
  .topdoli a {
    text-decoration: none;
    color: #808080;
    font-weight: 300;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue